import React from "react";
import { createRoot } from "react-dom/client";

import App from "../../App.js";
import "./index.css";

class WebErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  render() {
    if (this.state.error) {
      return (
        <div style={{ padding: 24, color: "#b91c1c", fontFamily: "system-ui, sans-serif" }}>
          <h2 style={{ marginTop: 0 }}>Procsystim web preview failed to load</h2>
          <pre style={{ whiteSpace: "pre-wrap", fontSize: 13 }}>{String(this.state.error?.stack || this.state.error)}</pre>
        </div>
      );
    }
    return this.props.children;
  }
}

const mountNode = document.getElementById("root");
if (!mountNode) {
  throw new Error("Missing #root element");
}

createRoot(mountNode).render(
  <WebErrorBoundary>
    <App />
  </WebErrorBoundary>,
);
